<template lang="pug">
.container.grid-xl
  filiated-dashboard(v-if="user.filiation")
  request-filiation-container(v-else)
</template>

<script>
import FiliatedDashboard from './components/FiliatedDashboard'
import RequestFiliationContainer from './components/RequestFiliationContainer'
import { mapState } from 'vuex'

export default {
  components: { FiliatedDashboard, RequestFiliationContainer },

  computed: {
    ...mapState('auth', ['user']),
  },
}
</script>
